import { useEffect, useState } from "react";
import axios from "axios";
import { CalendarDays, Users } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { formatCohortRange } from "../lib/cohorts";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CohortRegistrations = ({ getAuthHeader }) => {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    axios.get(`${API}/courses/cohort-registrations`, { headers: getAuthHeader() })
      .then((r) => setCourses(r.data.courses || []))
      .catch(() => setCourses([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!courses.length) return null;
  const max = Math.max(1, ...courses.flatMap((c) => c.cohorts.map((co) => co.total)));

  return (
    <Card className="mb-6" data-testid="cohort-registrations">
      <CardHeader>
        <CardTitle className="font-heading flex items-center gap-2">
          <CalendarDays className="h-5 w-5 text-brand" /> Scheduled Course Dates — Registrations
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {courses.map((c) => (
          <div key={c.id}>
            <p className="font-semibold mb-3">{c.title}</p>
            <div className="grid md:grid-cols-3 gap-3">
              {c.cohorts.map((co) => (
                <div key={co.id} className="border rounded-lg p-4" data-testid={`cohort-reg-${co.id}`}>
                  <p className="text-sm font-medium">{formatCohortRange(co)}</p>
                  <p className="font-heading font-bold text-3xl text-brand mt-2 flex items-center gap-2" data-testid={`cohort-reg-total-${co.id}`}>
                    <Users className="h-5 w-5" /> {co.total}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {co.paid} paid · {co.pending} awaiting payment · {co.orders} order{co.orders === 1 ? "" : "s"}
                  </p>
                  <div className="h-1.5 bg-slate-100 rounded-full mt-3 overflow-hidden">
                    <div className="h-full bg-brand transition-[width] duration-700" style={{ width: `${(co.total / max) * 100}%` }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
